import { useQuery } from "@tanstack/react-query";
import { getPublishedBlogs, getPublishedBlogBySlug } from "../api/publicBlogs";

export function usePublicBlogs() {
  const usePublicBlogsQuery = (page: number, size: number) =>
    useQuery({
      queryKey: ["publicBlogs", page, size],
      queryFn: () => getPublishedBlogs(page, size).then((res) => res.data),
      keepPreviousData: true,
    });

  const usePublicBlogBySlugQuery = (slug: string, enabled = true) =>
    useQuery({
      queryKey: ["publicBlog", slug],
      queryFn: () => getPublishedBlogBySlug(slug).then((res) => res.data),
      enabled: enabled && !!slug,
    });

  return {
    usePublicBlogsQuery,
    usePublicBlogBySlugQuery,
  };
}
